// ============================================================
// CONVERSATION MANAGER — RAG Batch 5
// Maintains multi-turn conversation context for AI search
// Each user session gets up to 10 turns of history
// ============================================================

const STORAGE_KEY = 'rag_conversations';
const MAX_TURNS = 10;
const MAX_SESSIONS = 50;

export const conversationManager = {

    // Get or create a session for a user
    getSession: (userId) => {
        const sessions = conversationManager.getAllSessions();
        if (!sessions[userId]) {
            sessions[userId] = {
                userId,
                sessionId: `sess_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
                turns: [],
                created: new Date().toISOString(),
                last_active: new Date().toISOString(),
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
        }
        return sessions[userId];
    },

    // Add a turn to a user's session
    addTurn: (userId, query, answer, citations = []) => {
        const sessions = conversationManager.getAllSessions();
        const session = sessions[userId] || {
            userId,
            sessionId: `sess_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
            turns: [],
            created: new Date().toISOString(),
        };

        session.turns.push({
            role_query: query,
            role_answer: answer,
            citations,
            timestamp: new Date().toISOString(),
        });

        // Keep only last MAX_TURNS turns
        if (session.turns.length > MAX_TURNS) {
            session.turns = session.turns.slice(-MAX_TURNS);
        }

        session.last_active = new Date().toISOString();
        sessions[userId] = session;

        // Keep only last MAX_SESSIONS sessions
        const sessionKeys = Object.keys(sessions);
        if (sessionKeys.length > MAX_SESSIONS) {
            // Remove oldest session
            const oldest = sessionKeys.sort((a, b) =>
                sessions[a].last_active.localeCompare(sessions[b].last_active)
            )[0];
            delete sessions[oldest];
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
        return session;
    },

    // Get conversation history formatted for Claude API
    getHistoryForPrompt: (userId) => {
        const session = conversationManager.getSession(userId);
        return session.turns.map(turn => [
            { role: 'user', content: turn.role_query },
            { role: 'assistant', content: turn.role_answer },
        ]).flat();
    },

    // Clear a user's session
    clearSession: (userId) => {
        const sessions = conversationManager.getAllSessions();
        delete sessions[userId];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
    },

    getAllSessions: () => {
        try {
            return JSON.parse(
                localStorage.getItem(STORAGE_KEY) || '{}'
            );
        } catch { return {}; }
    },
};
